export const JobPostingOptionalFieldMap = {
    phone: 1,
    country: 2,
    postal_code: 3,
};
